import { render, staticRenderFns } from "./AlertTray.vue?vue&type=template&id=2fd9a8df&"
import script from "./AlertTray.vue?vue&type=script&lang=ts&"
export * from "./AlertTray.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports